export default "__VITE_ASSET__c74ca7b9__"